var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "v-dialog",
        {
          staticClass: "popbox",
          attrs: {
            name: "dialog2",
            title: _vm.dialogTitle,
            "close-on-click-modal": "",
            modal: true,
            width: 668,
            "append-to-body": "",
          },
          on: {
            open: _vm.open,
            "after-close": _vm.handleAfterClose,
            confirm: _vm.handleConfirm,
          },
          model: {
            value: _vm.isShow,
            callback: function ($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow",
          },
        },
        [
          _c(
            "v-form",
            { ref: "form", attrs: { model: _vm.ruleForm, rules: _vm.rules } },
            [
              _c(
                "v-form-item",
                { attrs: { prop: "name" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("字段名称")]),
                  ]),
                  _c("v-input", {
                    attrs: { type: "text", name: "name" },
                    model: {
                      value: _vm.ruleForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "name", $$v)
                      },
                      expression: "ruleForm.name",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                { attrs: { prop: "identifier" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("字段标识")]),
                  ]),
                  _c("v-input", {
                    attrs: { type: "text", name: "identifier" },
                    model: {
                      value: _vm.ruleForm.identifier,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "identifier", $$v)
                      },
                      expression: "ruleForm.identifier",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                { attrs: { prop: "data_type" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("数据类型")]),
                  ]),
                  _c("v-select", {
                    attrs: {
                      id: "data_type",
                      name: "data_type",
                      options: _vm.dataTypeOptins,
                    },
                    model: {
                      value: _vm.ruleForm.data_type,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "data_type", $$v)
                      },
                      expression: "ruleForm.data_type",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                { attrs: { prop: "mark", required: false } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", [_vm._v("备注")]),
                  ]),
                  _c("v-input", {
                    staticClass: "Description",
                    attrs: {
                      type: "textarea",
                      maxlength: 254,
                      "show-word-limit": "",
                      name: "mark",
                    },
                    model: {
                      value: _vm.ruleForm.mark,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "mark", $$v)
                      },
                      expression: "ruleForm.mark",
                    },
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _c("v-loading", {
            staticClass: "loading-box",
            attrs: { visible: !_vm.upTips, name: "loading4" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }